<template>
	<div class="body-mid">
		<div style="background: #E5EDFB;">
			<div style="display: inline-block; font-size: 18px;font-weight: bold;line-height: 40px;color: white;
			padding: 0 20px;height: 40px;background: #0052D9;border-radius: 0px 20px 20px 0px;">
				权限设置
			</div>
		</div>
		<div style="padding: 30px ; box-sizing: border-box;border-bottom: 1px dashed #eee;padding-bottom: 0;">
			<h3>个人信息意愿</h3>
			<el-radio-group v-model="serveData.personal_information_type">
				<div style="display: flex;align-items: center;margin: 30px 0;">
					<div style="width: 200px;"> <el-radio :label="1">公开</el-radio></div>
					<div style="width: 200px;"> <el-radio :label="2">不公开</el-radio></div>
					<!-- <div style="width: 400px;"> <el-radio :label="3">以下级别公开</el-radio>
						<el-select v-model="value" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div> -->
				</div>
			</el-radio-group>
		</div>
		<div style="padding: 30px ; box-sizing: border-box;border-bottom: 1px dashed #eee;padding-bottom: 0;">
			<h3>承接项目意愿</h3>
			<el-radio-group v-model="serveData.project_aspiration">
				<div style="display: flex;align-items: center;margin: 30px 0;">
					<div style="width: 200px;"> <el-radio :label="1">接受推荐</el-radio></div>
					<div style="width: 200px;"> <el-radio :label="2">不接受推荐</el-radio></div>

				</div>
			</el-radio-group>
		</div>
		<div style="padding: 30px ; box-sizing: border-box;border-bottom: 1px dashed #eee;padding-bottom: 0;">
			<h3>被查询意愿</h3>
			<el-radio-group v-model="serveData.search_type">
				<div style="display: flex;align-items: center;margin: 30px 0;">
					<div style="width: 200px;"> <el-radio :label="1">完全公开</el-radio></div>
					<div style="width: 200px;"> <el-radio :label="2">可以被搜索到</el-radio></div>
					<div style="width: 400px;"> <el-radio :label="3">隐身</el-radio></div>
				</div>
			</el-radio-group>
		</div>
		<div style="padding: 30px ; box-sizing: border-box;border-bottom: 1px dashed #eee;padding-bottom: 0;">
			<h3>接受信息意愿</h3>
			<el-radio-group v-model="serveData.msg_type">
				<div style="display: flex;align-items: center;margin: 30px 0;">
					<div style="width: 200px;"> <el-radio :label="1">接收信息</el-radio></div>
					<div style="width: 200px;"> <el-radio :label="2">不接收信息</el-radio></div>
		
				</div>
			</el-radio-group>
		</div>
		<div @click="setPermissions" 
		style="margin:0 auto;width: 150px;height: 40px;background-color: #0052D9;margin-top: 30px;border-radius: 10px;color: white;text-align: center;line-height: 40px;cursor: pointer;">
			保存
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				serveData:{}
				// "personal_information_type": 1, //个人信息意愿：1公开2不公开3一下级别公开
				// "personal_information_need": "1,2", //可查看级别
				// "project_aspiration": 1, //承接项目意愿：1接受推送2不接受推送
				// "search_type": 1, //被查询意愿：1完全公开2可以被搜索到3隐身
				// "msg_type": 2, //接受信息意愿:1接受2不接收
			}
		},
		created() {
			this.getPermissions()
		},
		methods:{
			async setPermissions(){
				delete this.serveData.url
				const set = await this.$api.setPermissionsInfo({...this.serveData})
				if(set.code == 1){
					this.$message({
						message:set.msg,
						type:'success'
					})
				}else{
					this.$message({
						message:set.msg,
						type:'warning'
					})
				}
				console.log(set);
			},
			async getPermissions(){
				const info = await this.$api.getPermissionsInfo()
				this.serveData = info.data
			}
		}
	}
</script>
<style>
	/* .el-radio__label {
		color: black;
	}
	
	.radio {
		position: relative;
		display: inline-block;
		margin-right: 12px;
	}
	
	.radio input {
		width: 15px;
		height: 15px;
		appearance: none;
		-webkit-appearance: none;
		opacity: 0;
		outline: none;
	}
	.el-radio__input.is-checked+.el-radio__label{
		color: #0052D9;
	}
	.radio label {
		position: absolute;
		left: 0;
		top: 6px;
		width: 15px;
		height: 15px;
		border: 1px solid #bcbcbc;
	}
	
	.el-radio__inner {
		border-radius: 0;
	} */
	.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #0052D9;
		border-color: #0052D9;
	}
	/* .el-radio__inner::after {
		content: "";
		position: absolute;
		text-align: center;
		border-radius: 0;
		width: 14px;
		height: 14px;
		content: "✓";
		color: #fff;
		font-weight: bold;
		background-color: #0052D9;
	} */
</style>
<style scoped lang="less">
	/deep/.el-input__inner {
		border: 1px solid #eee;
	}

	.body-mid {
		padding: 30px 0;
		margin: 0 20px;
		width: 1120px;
		box-sizing: border-box;
		background: #fff;
	}
</style>